export const IconAccount = ({ width = 20, height = 21 }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.82016 7.16659C6.82016 5.60178 8.08869 4.33325 9.6535 4.33325C11.2183 4.33325 12.4868 5.60178 12.4868 7.16659C12.4868 8.73139 11.2183 9.99992 9.6535 9.99992C8.08869 9.99992 6.82016 8.73139 6.82016 7.16659ZM9.6535 3.33325C7.5364 3.33325 5.82016 5.04949 5.82016 7.16659C5.82016 9.28368 7.5364 10.9999 9.6535 10.9999C11.7706 10.9999 13.4868 9.28368 13.4868 7.16659C13.4868 5.04949 11.7706 3.33325 9.6535 3.33325ZM5.98416 14.2431C6.51551 13.7118 7.23618 13.4133 7.98763 13.4133H11.321C12.0724 13.4133 12.7931 13.7118 13.3244 14.2431C13.8558 14.7745 14.1543 15.4952 14.1543 16.2466V17.9133C14.1543 18.1894 14.3782 18.4133 14.6543 18.4133C14.9304 18.4133 15.1543 18.1894 15.1543 17.9133V16.2466C15.1543 15.23 14.7504 14.2549 14.0315 13.536C13.3126 12.8172 12.3376 12.4133 11.321 12.4133H7.98763C6.97097 12.4133 5.99594 12.8172 5.27705 13.536C4.55816 14.2549 4.1543 15.23 4.1543 16.2466V17.9133C4.1543 18.1894 4.37815 18.4133 4.6543 18.4133C4.93044 18.4133 5.1543 18.1894 5.1543 17.9133V16.2466C5.1543 15.4952 5.45281 14.7745 5.98416 14.2431Z'
      fill='var(--text-color)'
    />
  </svg>
);
